import React, { useState, useEffect, useCallback } from 'react';
import { API, C, authHeaders, btn, btnMain, inp } from './modApi';

function copyText(text, onOk) {
  try {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(onOk).catch(function () { fallback(text, onOk); });
    } else { fallback(text, onOk); }
  } catch (e) { fallback(text, onOk); }
}

function fallback(text, onOk) {
  try {
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    document.execCommand('copy');
    document.body.removeChild(ta);
    onOk();
  } catch (e) { alert('Could not copy - please select the text manually.'); }
}

function Translations({ qa, onClose, onChanged }) {
  const [d, setD] = useState(null);
  const [adding, setAdding] = useState('');
  const [text, setText] = useState('');
  const [busy, setBusy] = useState(false);
  const [copied, setCopied] = useState('');

  const load = useCallback(function () {
    fetch(API + '/qa/' + qa.id + '/translations/', { headers: authHeaders() })
      .then(function (r) { return r.json(); }).then(setD).catch(function () {});
  }, [qa.id]);
  useEffect(function () { load(); }, [load]);

  if (!d) return <p style={{ fontSize: 12, color: C.muted, padding: '1rem 0' }}>Loading...</p>;
  if (d.error) return <p style={{ fontSize: 12, color: C.danger, padding: '1rem 0' }}>{d.error}</p>;

  const doCopy = function (answer, key, trId) {
    copyText(answer, function () {
      setCopied(key);
      setTimeout(function () { setCopied(''); }, 1600);
      if (trId) {
        fetch(API + '/translations/' + trId + '/used/', { method: 'POST', headers: authHeaders() }).catch(function () {});
      } else {
        fetch(API + '/qa/' + qa.id + '/used/', { method: 'POST', headers: authHeaders() }).catch(function () {});
      }
    });
  };

  const saveTr = async function () {
    if (text.trim().length < 5) { alert('Write the answer properly.'); return; }
    setBusy(true);
    try {
      const res = await fetch(API + '/qa/' + qa.id + '/translations/', {
        method: 'POST', headers: authHeaders(),
        body: JSON.stringify({ language: adding, answer: text }) });
      const j = await res.json();
      if (!res.ok) throw new Error(j.error);
      setAdding(''); setText('');
      load();
      if (onChanged) onChanged();
    } catch (e) { alert(e.message); }
    setBusy(false);
  };

  const delTr = async function (t) {
    if (!window.confirm('Delete the ' + t.language_name + ' translation?')) return;
    try {
      const res = await fetch(API + '/translations/' + t.id + '/delete/', { method: 'POST', headers: authHeaders() });
      const j = await res.json();
      if (!res.ok) throw new Error(j.error);
      load();
      if (onChanged) onChanged();
    } catch (e) { alert(e.message); }
  };

  const Row = function ({ name, answer, used, trId, key2 }) {
    const isCopied = copied === key2;
    return (
      <div style={{ background: '#fff', border: '1px solid ' + C.border, borderRadius: 8, padding: '9px 11px', marginBottom: 6 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
          <span style={{ fontSize: 12.5, fontWeight: 700 }}>{name}</span>
          <span style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
            {used ? <span style={{ fontSize: 10, color: C.muted }}>used {used}x</span> : null}
            <button onClick={function () { doCopy(answer, key2, trId); }}
              style={{ ...btn, background: isCopied ? C.primaryBg : '#fff',
                       color: isCopied ? C.primary : C.muted,
                       borderColor: isCopied ? C.primary : C.border, fontWeight: 700 }}>
              {isCopied ? 'Copied' : 'Copy'}
            </button>
            {trId ? <button onClick={function () { delTr({ id: trId, language_name: name }); }}
              style={{ border: 'none', background: 'none', cursor: 'pointer', fontSize: 12, color: C.danger }}>x</button> : null}
          </span>
        </div>
        <p style={{ margin: '5px 0 0', fontSize: 12.5, color: C.text, whiteSpace: 'pre-wrap', lineHeight: 1.6 }}>{answer}</p>
      </div>
    );
  };

  return (
    <div style={{ background: C.surface, borderRadius: 9, padding: 11, marginTop: 8 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 9 }}>
        <span style={{ fontSize: 12.5, fontWeight: 700 }}>Answers in every language</span>
        <button onClick={onClose} style={{ border: 'none', background: 'none', cursor: 'pointer', fontSize: 15, color: C.muted }}>x</button>
      </div>

      <Row name="English (original)" answer={d.qa.answer} used={d.qa.times_used} trId={null} key2="en" />

      {d.translations.map(function (t) {
        return <Row key={t.id} name={t.language_name} answer={t.answer} used={t.times_used} trId={t.id} key2={'t' + t.id} />;
      })}

      {adding ? (
        <div style={{ background: '#fff', border: '1px solid ' + C.primary, borderRadius: 8, padding: 10, marginTop: 8 }}>
          <p style={{ margin: '0 0 6px', fontSize: 12.5, fontWeight: 700 }}>
            Add the answer in {(d.missing.filter(function (m) { return m.code === adding; })[0] || {}).name || adding}
          </p>
          <textarea value={text} onChange={function (e) { setText(e.target.value); }} rows={4}
            placeholder="Write the answer as a Pioneer would read it." style={{ ...inp, resize: 'vertical' }} />
          <div style={{ display: 'flex', gap: 6 }}>
            <button onClick={saveTr} disabled={busy} style={btnMain}>{busy ? 'Saving...' : 'Save'}</button>
            <button onClick={function () { setAdding(''); setText(''); }} style={btn}>Cancel</button>
          </div>
        </div>
      ) : d.missing.length > 0 ? (
        <div style={{ marginTop: 9 }}>
          <p style={{ margin: '0 0 5px', fontSize: 11, color: C.muted }}>Missing - tap to add:</p>
          <div style={{ display: 'flex', gap: 5, flexWrap: 'wrap' }}>
            {d.missing.map(function (m) {
              return <button key={m.code} onClick={function () { setAdding(m.code); }}
                style={{ ...btn, fontSize: 11, padding: '4px 9px' }}>+ {m.name}</button>;
            })}
          </div>
        </div>
      ) : null}
    </div>
  );
}

export default function QATab() {
  const [d, setD] = useState(null);
  const [q, setQ] = useState('');
  const [cat, setCat] = useState('');
  const [openTr, setOpenTr] = useState(null);
  const [showAdd, setShowAdd] = useState(false);
  const [form, setForm] = useState({ question: '', answer: '', keywords: '', category: '' });
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState('');
  const [copied, setCopied] = useState(0);

  const load = useCallback(function () {
    const p = new URLSearchParams();
    if (q) p.set('q', q);
    if (cat) p.set('category', cat);
    fetch(API + '/qa/?' + p, { headers: authHeaders() })
      .then(function (r) { return r.json(); }).then(setD).catch(function () {});
  }, [q, cat]);

  useEffect(function () {
    const t = setTimeout(load, 300);
    return function () { clearTimeout(t); };
  }, [load]);

  if (!d) return <p style={{ color: C.muted, textAlign: 'center', padding: '2rem 0' }}>Loading...</p>;
  if (d.error) return <p style={{ color: C.danger, textAlign: 'center', padding: '2rem 0' }}>{d.error}</p>;

  const quickCopy = function (a) {
    copyText(a.answer, function () {
      setCopied(a.id);
      setTimeout(function () { setCopied(0); }, 1600);
      fetch(API + '/qa/' + a.id + '/used/', { method: 'POST', headers: authHeaders() }).catch(function () {});
    });
  };

  const save = async function () {
    if (form.question.trim().length < 5) { setMsg('Write the question properly.'); return; }
    if (form.answer.trim().length < 5) { setMsg('Write the answer properly.'); return; }
    setBusy(true); setMsg('');
    try {
      const res = await fetch(API + '/qa/add/', {
        method: 'POST', headers: authHeaders(), body: JSON.stringify(form) });
      const j = await res.json();
      if (!res.ok) throw new Error(j.error);
      setForm({ question: '', answer: '', keywords: '', category: '' });
      setShowAdd(false);
      load();
    } catch (e) { setMsg(e.message); }
    setBusy(false);
  };

  return (
    <>
      <input value={q} onChange={function (e) { setQ(e.target.value); }}
        placeholder="Search - type two or three words" style={{ ...inp, fontSize: 14, padding: '10px 13px' }} />

      <div style={{ display: 'flex', gap: 5, flexWrap: 'wrap', marginBottom: 11 }}>
        <button onClick={function () { setCat(''); }}
          style={{ ...btn, background: cat ? '#fff' : C.primaryBg, color: cat ? C.muted : C.primary, fontWeight: cat ? 400 : 700 }}>
          All ({d.count})
        </button>
        {(d.categories || []).map(function (c) {
          const on = cat === c.name;
          return <button key={c.name} onClick={function () { setCat(on ? '' : c.name); }}
            style={{ ...btn, background: on ? C.primaryBg : '#fff', color: on ? C.primary : C.muted, fontWeight: on ? 700 : 400 }}>
            {c.name} ({c.count})
          </button>;
        })}
        <button onClick={function () { setShowAdd(!showAdd); }} style={{ ...btnMain, marginLeft: 'auto' }}>+ Add</button>
      </div>

      {showAdd ? (
        <div style={{ background: '#fff', border: '1px solid ' + C.border, borderRadius: 10, padding: 13, marginBottom: 12 }}>
          <p style={{ margin: '0 0 3px', fontSize: 13.5, fontWeight: 700 }}>Add a question and answer</p>
          <p style={{ margin: '0 0 9px', fontSize: 11, color: C.muted, lineHeight: 1.5 }}>
            Write it in English first. Other languages are added on top of it afterwards.
          </p>
          <input value={form.question} onChange={function (e) { setForm({ ...form, question: e.target.value }); }}
            placeholder="The question, as a Pioneer would ask it" style={inp} />
          <textarea value={form.answer} onChange={function (e) { setForm({ ...form, answer: e.target.value }); }} rows={5}
            placeholder="The answer, ready to paste into a chat" style={{ ...inp, resize: 'vertical' }} />
          <div style={{ display: 'flex', gap: 7 }}>
            <input value={form.category} onChange={function (e) { setForm({ ...form, category: e.target.value }); }}
              placeholder="Category (KYC, wallet...)" style={inp} />
            <input value={form.keywords} onChange={function (e) { setForm({ ...form, keywords: e.target.value }); }}
              placeholder="Other words that should find it" style={inp} />
          </div>
          {msg ? <p style={{ fontSize: 12, color: C.danger, margin: '0 0 8px' }}>{msg}</p> : null}
          <div style={{ display: 'flex', gap: 7 }}>
            <button onClick={save} disabled={busy} style={btnMain}>{busy ? 'Saving...' : 'Save'}</button>
            <button onClick={function () { setShowAdd(false); setMsg(''); }} style={btn}>Cancel</button>
          </div>
        </div>
      ) : null}

      {d.items.length === 0 ? (
        <p style={{ textAlign: 'center', color: C.muted, fontSize: 12.5, padding: '2rem 1rem' }}>
          {q ? 'Nothing found for "' + q + '".' : 'No answers saved yet. Add the first one.'}
        </p>
      ) : d.items.map(function (a) {
        return (
          <div key={a.id} style={{ background: '#fff', border: '1px solid ' + C.border, borderRadius: 9, padding: '11px 13px', marginBottom: 8 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8, flexWrap: 'wrap' }}>
              <span style={{ fontSize: 13.5, fontWeight: 600, flex: 1 }}>{a.question}</span>
              <button onClick={function () { quickCopy(a); }}
                style={{ ...btn, background: copied === a.id ? C.primaryBg : '#fff',
                         color: copied === a.id ? C.primary : C.muted,
                         borderColor: copied === a.id ? C.primary : C.border, fontWeight: 700 }}>
                {copied === a.id ? 'Copied' : 'Copy'}
              </button>
            </div>

            <p style={{ margin: '5px 0', fontSize: 12.5, color: C.text, whiteSpace: 'pre-wrap', lineHeight: 1.6 }}>{a.answer}</p>

            <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8, flexWrap: 'wrap', marginTop: 6 }}>
              <span style={{ fontSize: 10.5, color: C.muted }}>
                {a.category ? a.category + ' - ' : ''}used {a.times_used}x
                {a.added_by ? ' - by ' + a.added_by : ''}
              </span>
              <button onClick={function () { setOpenTr(openTr === a.id ? null : a.id); }}
                style={{ ...btn, fontSize: 11, padding: '4px 10px',
                         color: a.translations > 0 ? C.primary : C.muted,
                         borderColor: a.translations > 0 ? C.primary : C.border }}>
                {a.translations > 0 ? a.translations + ' more languages' : 'Add a language'}
              </button>
            </div>

            {openTr === a.id ? (
              <Translations qa={a} onClose={function () { setOpenTr(null); }} onChanged={load} />
            ) : null}
          </div>
        );
      })}
    </>
  );
}
